import React, { useState, useContext,useRef } from 'react';
// import styled from 'styled-components';
import Navbar from '../layouts/navbar';
import './logincard.css';
// import Logincard from  './logincard';
import Parse from 'parse';
import swal from 'sweetalert';
import { Redirect } from 'react-router-dom';
import { AuthContext } from '../../auth';
import { AudiosrcContext } from '../../Audio';
import { PeerjsContext } from '../../peerContext';
import Peer from 'peerjs';
import { Link } from 'react-router-dom';


// import { fn } from 'moment';


const Login = (props) => {
    console.log(props);

    const [name, setName] = useState("");
    const [pass, setPass] = useState("");
    const [Onaudiocall, setOnaudiocall] = useState(false);
    const [logedinuser, setLogedinuser] = useContext(AuthContext);
    const peerRef = useContext(PeerjsContext);
    const [audioSrc, setAudioSrc] = useContext(AudiosrcContext);
    const audio = useRef();
    let audiox;
    const [re,setRe] = useState(props.location.re);
  

    const handleSubmit = (e) => {
        e.preventDefault();
        async function fn() {
            // TODO: Add try catch
            try {
                const user = await Parse.User.logIn(name, pass);
                console.log(user);
                const isCounsellor = user.get("isCounsellor");
                if (!user) {
                    swal("Oops!", "no user..wrong email or password", "error");
                } else {
                    console.log(isCounsellor);
                    if (isCounsellor) {
                        swal("Oops!", "This is login for dependant..log in as counsellor", "error");
                    } else {
                        setLogedinuser(user.id);
                        peerRef.current = new Peer();
                        console.log('Connecting peer');
                        peerRef.current.on('open', function (id) {
                            console.log(id);
                            user.set("peerId", id);
                            user.save().then((obj) => {
                                // navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia;
                                // peerRef.current.on('call', (call) => {
                                //     navigator.getUserMedia({ audio: true }, (stream) => {
                                //         call.answer(stream); // Answer the call with an A/V stream.
                                //         call.on('stream', (remoteStream) => {
                                //             // setOnaudiocall(true);
                                //             // setAudioSrc(remoteStream);
                                //             // if(Onaudiocall?audiox = (<div>
                                //             //         <audio autoPlay={true} ref={audio}></audio>
                                //             //  </div>):null)
                                //             // let audio = (<div>
                                //             //     <audio autoPlay={true} ref={audio}></audio>
                                //             // </div>)
                                //             // <div>
                                //             //      <audio autoPlay={true} ref={audio}></audio>
                                //             //  </div>
                                //         });
                                //     }, (err) => {
                                //         console.error('Failed to get local stream', err);
                                //     });
                                //     console.log("saved" + obj);
                                // }).catch(err => console.log(err))
                                //send id to parse
                                console.log(obj);
                            });

                        })
                    }
                }
            }
            catch (e) {
                console.log(e)
                swal("Oops!", "no user..wrong email or password", "error");

            }


            // RECEIVING CALLS: (Also add to counsellor login and signup)
            // await connect to peerjs
            // Post peerjs id to parse
            // keep peerjs object as a ref in context (elaborate)
            // add appropriate listeneners to the ref object

        }
        fn();
    }
    

    return (
        <div>
            <Navbar head="Login"/>
           

            {console.log("noooooo")}
            {(logedinuser != null) && (
                <Redirect to="/" />
            )}


            
             {console.log(logedinuser)}
            {console.log(re !=null)}
            {(logedinuser != null)&&(
               re !=null
            )&&
            ( <Redirect to={re} />)}

            <div className="container cnt" style={{marginTop:"60px"}} >
                {/* <Logincard /> */}
                <h1 className="head1">Login to your Account</h1>
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="form-group col-lg-12  ">
                            <input type="text"
                                className="form-control"
                                id="exampleInputEmail1"
                                value={name}
                                onChange={e => setName(e.target.value)}
                                aria-describedby="emailHelp"
                                placeholder="user name" />
                        </div>
                        <div className="form-group col-lg-12 ">
                            <input type="password"
                                className="form-control"
                                id="pwd"
                                value={pass}
                                onChange={e => setPass(e.target.value)}
                                placeholder="password" />
                        </div>
                        {/* <div className="checkbox">
                            <label><input type="checkbox" value="" />Remember me</label>
                        </div> */}
                    {/* {audio} */}
                    </div>
                    <div className="btndiv">
                        <button type="submit" class="authbtn btn-primary center-block mt-4">Submit</button>
                    </div>
                </form>
                <div className="signupdiv">Dont have an account? <br /><Link to="/register">Sign up</Link></div>
            </div>
           
        </div>
    );
};



export default Login;


